import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription }  from 'rxjs/Subscription';
import { SharedService } from './../../shared/shared.service';
import { TopUpService } from './top-up.service'
import { AgencyInfo } from '../../shared/agency.model';

@Component({
  selector: 'app-top-up',
  templateUrl: './top-up.component.html',
  styleUrls: ['./top-up.component.css']
})
export class TopUpComponent implements OnInit {

  public agency : AgencyInfo;
  public serviceError: string;
	public successMsg : string;
	private sub1 : Subscription;
	private sub2 : Subscription;
	private decimalPoints:number=2;
  
  constructor(
		private router:Router, 
		private sharedService : SharedService, 
		private topUpService : TopUpService) { }
	
	formErrors = {
		'isIncrement': '',
		'newCreditLimit': ''
  };
	validationMessages = {
		'isIncrement': {
			'required': 'This field is required'
		},
		'newCreditLimit': {
			'required': 'This field is required',
			'isNumeric': 'IATA Number should be numeric',
			'noWhitespace': 'IATA Number is required',
			'pattern':'Please enter valid Credit Limit with '+this.decimalPoints+' decimal points'
		}
	}

  TopUpForm : FormGroup;
  ngOnInit() {
		this.sharedService.showAgencyInformation = true;
    this.agency = new AgencyInfo(this.sharedService.getAgencyInfoDetails());
		let pattern=/^[0-9]+(\.[0-9]{2})?$/;
		if(this.sharedService.isThreeDecimalPlaces()){
			pattern=/^[0-9]+(\.[0-9]{3})?$/;
			this.decimalPoints=3;
			this.reSetValidationMessages();
		}
    this.TopUpForm = new FormGroup({
      'isIncrement': new FormControl('true'),
			'newCreditLimit': new FormControl('',Validators.compose([
				Validators.required,
				Validators.pattern(pattern)]
				))
		});
		this.sub1 = this.TopUpForm.valueChanges.subscribe(data => {
	      	this.onValueChanged(data);
		});
    this.onValueChanged();

	}
	reSetValidationMessages() {
		this.validationMessages = {
			'isIncrement': {
				'required': 'This field is required'
				},
				'newCreditLimit': {
				'required': 'This field is required',
				'isNumeric': 'IATA Number should be numeric',
				'noWhitespace': 'IATA Number is required',
				'pattern':'Please enter valid Credit Limit with '+this.decimalPoints+' decimal points'
			}
	}
}
	onValueChanged(data ? : any) {
	  	if (!this.TopUpForm) { return; }
			const form = this.TopUpForm;
	    for (const field in this.formErrors) {
		    this.formErrors[field] = '';
				const control = form.get(field);
	      	if (control) {
		        const messages = this.validationMessages[field];
		        for (const key in control.errors) {	
								this.formErrors[field] += messages[key] + ' ';
		          	break;
		        }
	      	}
    	}
	}
  
  //onCancel
  cancel() {
		// for (let i in this.TopUpForm.controls) {
    //   this.TopUpForm.controls[i].markAsUntouched();
    // }
		// this.TopUpForm.reset();
		this.router.navigate(['/dashboard'],{queryParams: {}});
	}

  //On form submit for TopUp
  	submitForm(formDetails: any):void {
		  this.serviceError = '';
			this.successMsg='';
      for (let i in this.TopUpForm.controls) {
          this.TopUpForm.controls[i].markAsTouched();
      }
			if (this.TopUpForm.valid) {
				     if(confirm("Changes have been made to the credit limit, Do you want to continue with the change?",)) {
							         formDetails.iataNumber = this.agency.iatacode;
        this.topUpService.submitFormDetails(formDetails).subscribe((response) => {	       
		        if(response.status == 'success') {
							this.agency.creditLimit=response.result.availableCredit;
							this.agency.actualCreditLimit=response.result.creditLimit;
							this.successMsg=response.message;
		        } else if(response.status == 'error') {
		        	this.serviceError = response.message;
		        }
		    },
		    (error) => {
		      this.serviceError = JSON.parse(error.Error).message;
				});
				this.TopUpForm.reset();
				//this.TopUpForm[0]=true;

    }

	    }
	}
  resetForm() {
		this.TopUpForm.reset();
		this.serviceError = '';
	}
	ngOnDestroy(){
  	this.sharedService.showAgencyInformation = false;
  }
	// omit_special_char(event){   
	// 	var k;  
	// 	k = event.charCode;  // k = event.keyCode;  (Both can be used)
	// 	return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
	// }
	numbersOnly(event){   
		var k;  
		k = event.charCode;  // k = event.keyCode;  (Both can be used)
		return((k >= 48 && k <= 57)); 
	}
}



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/create-agency/top-up/top-up.component.ts